// Anesthesia Coverage Search (the /company/find-providers desk) sits behind
// one build-time switch, REACT_APP_AVAILABILITY_SEARCH_ENABLED. Every surface
// that names the search or links to it reads the switch here, so with it off
// nothing mentions the search and nothing links to a route that is not there.
//
// CRA inlines REACT_APP_* at build time, so both forms below are constant in
// a build. Module-scope consumers (the route table, the nav items, the
// schedule-check step) take the constant; render-time consumers call the
// function, which lets a test flip the switch without reloading modules.
export function isAvailabilitySearchEnabled() {
  return (
    String(process.env.REACT_APP_AVAILABILITY_SEARCH_ENABLED ?? 'false')
      .trim()
      .toLowerCase() === 'true'
  );
}

export const AVAILABILITY_SEARCH_ENABLED = isAvailabilitySearchEnabled();
